export enum BuildStatus {
    Succeeded = 1,
    Stopped,
    PartiallySucceeded,
    Failed,
    Running,
    NotRunnable,
    Initializing,
    Unknown,
}
